import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";

import MegaMenu from "components/MegaMenu";
import Topbar from "./Topbar";
import Navbar from "./Navbar";
import Hero from "./Hero";
import { HeroSkeleton } from "components/Skeleton";

import { HeaderWrapper } from "./styles/HeaderStyles";

import bg from "images/pattern-hero.png";

const Header = ({ hero }) => {
  const { isLoading, activeMegaMenu, heroData } = useContext(GlobalContext);
  // Whenever a hero (or its skeleton) shows, it fills the first screen.
  const fullHeight =
    hero && !activeMegaMenu && (isLoading || !!heroData.image.sourceUrl);

  return useMemo(() => {
    return (
      <React.Fragment>
        <HeaderWrapper
          className={`header ${fullHeight ? "header--full" : ""}`}
          bg={bg}
        >
          <Topbar />
          <Navbar />
          {activeMegaMenu ? (
            <MegaMenu />
          ) : isLoading ? (
            hero && <HeroSkeleton />
          ) : (
            hero && heroData.image.sourceUrl && <Hero />
          )}
        </HeaderWrapper>
      </React.Fragment>
    );
  }, [isLoading, activeMegaMenu, heroData, fullHeight]);
};

Header.propTypes = {
  hero: PropTypes.bool,
};

Header.defaultProps = {
  hero: true,
};

export default Header;
